const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector("div")

  if (!tooltipEl) {
    tooltipEl = document.createElement("div")

    tooltipEl.classList.add(
      "bg-white",
      "border",
      "border-custom-blue-8",
      "shadow-lg",
      "absolute",
      "text-xs",
    )

    tooltipEl.style.pointerEvents = "none"
    tooltipEl.style.opacity = 1
    tooltipEl.style.transform = "translate(-50%, 0)"
    tooltipEl.style.transition = "all .1s ease"

    const table = document.createElement("table")

    tooltipEl.appendChild(table)
    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}

const cellClasses = (i) => {
  const classes = []

  if (i === 0) {
    classes.push("font-semibold", "whitespace-pre")
  } else {
    classes.push("text-right", "px-2", "py-1")

    if (i > 1) {
      classes.push("border-l", "border-custom-gray-4")
    }
  }
  return classes
}

const buildTooltip = (
  context,
  { head, body, foot },
  { showColor = false } = {},
) => {
  // Tooltip Element
  const { chart, tooltip } = context

  const tooltipEl = getOrCreateTooltip(chart)

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Head

  const tableHead = document.createElement("thead")
  const headRow = document.createElement("tr")

  const th = document.createElement("th")
  th.appendChild(document.createTextNode(head))
  th.colSpan = "100"
  headRow.appendChild(th)

  tableHead.appendChild(headRow)

  // Body

  const tableBody = document.createElement("tbody")

  body.forEach((row) => {
    const tr = document.createElement("tr")

    row.forEach((cell, i) => {
      const td = document.createElement("td")

      if (showColor && i === 0) {
        const item = chart.legend.legendItems.find((item) => item.text === cell)

        if (item && typeof item.fillStyle === "string") {
          const span = document.createElement("span")
          span.style.background = item.fillStyle
          span.style.marginRight = "4px"
          span.style.height = "10px"
          span.style.width = "10px"
          span.style.display = "inline-block"
          td.appendChild(span)
        }
      }

      td.appendChild(document.createTextNode(cell))
      tr.appendChild(td)

      td.classList.add(...cellClasses(i))
    })

    tableBody.appendChild(tr)
  })

  // Foot

  const tableFoot = document.createElement("tfoot")
  const footRow = document.createElement("tr")
  footRow.classList.add("border-t", "border-custom-gray-4")

  foot.forEach((cell, i) => {
    const td = document.createElement("td")
    td.appendChild(document.createTextNode(cell))
    footRow.appendChild(td)

    td.classList.add(...cellClasses(i))
  })

  tableFoot.appendChild(footRow)

  const tableRoot = tooltipEl.querySelector("table")

  // Remove old children
  while (tableRoot.firstChild) {
    tableRoot.firstChild.remove()
  }

  // Add new children
  tableRoot.appendChild(tableHead)
  tableRoot.appendChild(tableBody)
  tableRoot.appendChild(tableFoot)

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1
  tooltipEl.style.left = positionX + tooltip.caretX + "px"
  tooltipEl.style.top = positionY + tooltip.caretY + "px"
  tooltipEl.style.font = tooltip.options.bodyFont.string
  tooltipEl.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px"
}

export { buildTooltip }
